import { useRef, useState } from "react";
import UploadIcon from "../../assets/icons/upload.svg";
import CloseIcon from "../../assets/icons/close_grey.svg";
import DocImg from "../../assets/images/doc.png";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import FileImg from "../../assets/icons/file.svg";
import "./CustomFileInput.css";

const CustomFileInput = ({
  placeholder,
  fileName,
  updateUserData,
  field,
  type,
  className = "",
  isRequired = false,
  showOptional = false,
  isError,
}) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(null);
  const fileRef = useRef();

  const formatFileSize = (size) => {
    if (size < 1024) {
      return `${size} bytes`;
    } else if (size >= 1024 && size < 1048576) {
      return `${(size / 1024).toFixed(2)} KB`;
    } else if (size >= 1048576) {
      return `${(size / 1048576).toFixed(2)} MB`;
    }
  };

  const handleFileChange = (e, clear = false) => {
    setFileSizeError(false);
    if (!clear) {
      const file = e.target.files[0];
      const checkfileSize = (file?.size / 1048576).toFixed(2) > 2;
      if (checkfileSize) {
        setFileSizeError(true);
        return;
      }
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
          setFileType(file.type);
          setFileSize(formatFileSize(file.size));
        };
        reader.readAsDataURL(file);
        updateUserData({
          value: file,
          field: field,
          type: type,
        });
      }
    } else {
      setImagePreview(null);
      setFileType(null);
      setFileSize(null);
      updateUserData({
        value: e,
        field: field,
        type: type,
      });
      fileRef.current.value = "";
    }
  };

  const getFileName = (name) => {
    let updatedName = name.split("/");
    return updatedName[updatedName.length - 1];
  };

  return (
    (isRequired || (showOptional && !isRequired)) && (
      <div className="flex flex-col">
        <div
          className={`flex flex-col file-browse ${className} ${
            (isError && !fileName && isRequired) || fileSizeError
              ? "error-border"
              : ""
          }`}
        >
          <div className="flex items-center file-upload">
            <input
              type="file"
              className="resume-input"
              onChange={handleFileChange}
              accept=".jpeg,.png,.pdf,.jpg"
              ref={fileRef}
            />
            <div className="flex items-center upload-placeholder">
              <img src={UploadIcon} className="upload-icon" alt="" />
              <div className="browse-text">Browse Files</div>
            </div>
          </div>
          <div className="flex justify-between upload-desc">
            <div className="upload-text">
              {fileName && typeof fileName === "string"
                ? getFileName(fileName)
                : placeholder}
              {isRequired && "*"}
            </div>
            <div className="max-value">
              {fileSize ? fileSize : "Maximum 2 MB"}
            </div>
          </div>
          {fileType && (
            <div
              className="image-preview"
              style={{
                position: "absolute",
                left: "100px",
                bottom: "48px",
                backgroundColor: "grey",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                height: "100px",
                width: "191px",
              }}
            >
              {fileType.includes("image") && imagePreview && (
                <img
                  style={{
                    height: "100px",
                    width: "191px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                    position: "relative",
                    objectFit: "contain",
                  }}
                  src={imagePreview}
                  alt="ImagePreview"
                />
              )}
              {fileType.includes("application") && (
                <img
                  style={{
                    height: "100px",
                    width: "191px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                    position: "relative",
                    objectFit: "cover",
                  }}
                  src={DocImg}
                  alt="DocFile"
                />
              )}
              <img
                src={CloseIcon}
                alt=""
                style={{
                  height: "20px",
                  width: "20px",
                  position: "absolute",
                  bottom: "88px",
                  left: "180px",
                  backgroundColor: "white",
                  borderRadius: "15px",
                  border: "1px solid",
                }}
                onClick={() => handleFileChange({}, true)}
              />
            </div>
          )}
          {fileName && !fileType && (
            <div
              className="image-preview"
              style={{
                position: "absolute",
                left: "100px",
                bottom: "48px",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                height: "100px",
                width: "191px",
              }}
            >
              <img
                style={{
                  height: "120px",
                  width: "191px",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                  position: "relative",
                }}
                src={FileImg}
                alt="DocFile"
              />
              <img
                src={CloseIcon}
                alt=""
                style={{
                  height: "20px",
                  width: "20px",
                  position: "absolute",
                  bottom: "80px",
                  left: "145px",
                  backgroundColor: "white",
                  borderRadius: "15px",
                  border: "1px solid",
                }}
                onClick={() => handleFileChange("", true)}
              />
            </div>
          )}
        </div>
        {isError && !fileName && isRequired && (
          <div className="valid-text flex items-center ml-2">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Please select a file to upload</div>
          </div>
        )}
        {fileSizeError && (
          <div className="valid-text flex items-center ml-2">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Maximum 2 MB file is allowed for upload</div>
          </div>
        )}
      </div>
    )
  );
};
export default CustomFileInput;
